import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { getcontact, deletecontacts } from '../../ReduxToolkit/Slice/Contact/Conact';
import CommanTable from '../../components/Table/CommanTable';


function Contact() {
  const dispatch = useDispatch();
  const { status, contacts } = useSelector((state) => state.contact || { status: 'idle', contact: { data: [] } });



  //  get
  useEffect(() => {
    if (status === "idle") {
      dispatch(getcontact())
    }
  }, [dispatch, status]);
  // delete api
  const handleDelete = (contactid) => {
    const Isconfirmed = window.confirm("Are you sure! you want delete this Contact Details")
    if (Isconfirmed) {
      dispatch(deletecontacts(contactid))
    };
  }
  function formatDate(dateString) {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  }
  const columns = [
    { label: "Name", accessor: "name" },
    { label: "Email", accessor: "email" },
    { label: "phone", accessor: "phone" },
    { label: "Resaon", accessor: "resaon" },
    { label: "Date", accessor: "createdAt", formatter: formatDate },

  ];
  return (
    <>
      <div>
        <div className='d-flex justify-content-between my-3'>
          <h3>Contact Forms</h3>
        </div>

        <CommanTable
          columns={columns}
          data={contacts.data || []}
          status={status}
          onDelete={handleDelete}
          
        />
      </div>
    </>
  );
}

export default Contact;
